import axios from "axios";
import port from "../helper.js";
import Cookies from "js-cookie";
import { useAuthStore } from "../store/useAuthStore.js";

export const axiosInstance = axios.create({
    baseURL: `${port}`,
    withCredentials: true,
});


axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry &&
            error.response?.data?.message === "Access token expired"
        ) {
            originalRequest._retry = true;
            try {
                await useAuthStore.getState().refreshToken(); // call refresh function from authStore
                const newAccessToken = Cookies.get("accessToken");

                if (newAccessToken) {
                    originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
                }

                return axiosInstance(originalRequest); // retry original request
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);